<template>
  <div class="super-admin-ident">
    <img class="super-admin-ident__icon" src="static/img/icon_superuser.svg" alt="Admin">
    <span v-if="!hideText" class="super-admin-ident__text">{{ $t('labels.superadmin') }}</span>
  </div>
</template>
<script>
  export default {
    props: {
      hideText: {
        type: Boolean,
        default: false
      }
    }
  }
</script>
<style lang="scss">
.super-admin-ident {
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  color: #52B12D;
  cursor: default;

  @media (max-width: 360px){
    font-size: 10px !important;
  }

  &__text {
    margin-left: 5px;
  }
}
</style>